import { Builder } from '@builder.io/react';

import HeroProduct from './index';

Builder.registerComponent(HeroProduct, {
  name: 'Hero Product',
  inputs: [
    {
      name: 'logo',
      type: 'object',
      subFields: [
        {
          name: 'src',
          type: 'file',
          allowedFileTypes: ['jpeg', 'svg', 'png']
        },
        {
          name: 'alt',
          type: 'string'
        },
        {
          name: 'width',
          type: 'number'
        },
        {
          name: 'height',
          type: 'number'
        },
        {
          name: 'widthMobile',
          type: 'number'
        },
        {
          name: 'heightMobile',
          type: 'number'
        }
      ]
    },
    {
      name: 'title',
      type: 'string'
    },
    {
      name: 'subtitle',
      type: 'richText'
    },
    {
      name: 'asset',
      type: 'object',
      subFields: [
        {
          name: 'src',
          type: 'file',
          allowedFileTypes: ['jpeg', 'svg', 'png']
        },
        {
          name: 'alt',
          type: 'string'
        },
        {
          name: 'width',
          type: 'number'
        },
        {
          name: 'height',
          type: 'number'
        },
        { name: 'overflowing', type: 'boolean', defaultValue: true }
      ]
    },
    {
      name: 'video',
      type: 'object',
      subFields: [
        {
          name: 'src',
          type: 'string'
        },
        {
          name: 'poster',
          type: 'file',
          allowedFileTypes: ['jpeg', 'svg', 'png', 'jpg']
        },
        {
          name: 'muted',
          type: 'boolean',
          defaultValue: true
        }
      ]
    },
    { name: 'spacing', type: 'string', enum: ['sm', 'md'], defaultValue: 'md' },
    {
      name: 'cta',
      type: 'object',
      subFields: [
        {
          name: 'buttons',
          type: 'list',
          defaultValue: [
            {
              text: 'Get Started',
              href: '/sales',
              type: 'primary',
              variant: 'default'
            }
          ],
          subFields: [
            {
              name: 'text',
              type: 'string'
            },
            {
              name: 'href',
              type: 'url'
            },
            {
              name: 'type',
              type: 'string',
              defaultValue: 'primary',
              enum: ['primary', 'secondary']
            },
            {
              name: 'variant',
              type: 'string',
              defaultValue: 'default',
              enum: ['default', 'transparent']
            }
          ]
        },
        {
          name: 'hubspotModal',
          type: 'object',
          subFields: [
            {
              name: 'formId',
              type: 'string'
            },
            {
              name: 'sfdcCampaignId',
              type: 'string'
            },
            {
              name: 'label',
              type: 'string'
            },
            {
              name: 'type',
              type: 'string',
              defaultValue: 'primary',
              enum: ['primary', 'secondary']
            },
            {
              name: 'variant',
              type: 'string',
              defaultValue: 'default',
              enum: ['default', 'transparent']
            }
          ]
        }
      ]
    }
  ]
});
